export const RESOURCE_MANAGEMENT_TAB_ENUM = {
  TIMELINE: 'TIMELINE',
  LIST: 'LIST',
  OVERVIEW: 'OVERVIEW'
};
